module.exports = __webpack_public_path__ + "catalog/items/down-arrow/downarrow.svg";